import React, { useState } from "react";
import CustomModal from "../../../../../../components/CustomModal";
import InputCustom from "../../../../../../components/InputCustom";
import { FrontendNotification, NotificationType } from "../../../../../../shared/Notification";

interface Props {
  onClose: () => void;
  onConfirm: (valor: number, justificativa: string) => void;
}

const ModalSangria: React.FC<Props> = ({ onClose, onConfirm }) => {
  const [valor, setValor] = useState<string>("");
  const [justificativa, setJustificativa] = useState<string>("");

  const formatCurrency = (value: string) => {
    const numericValue = value.replace(/\D/g, "");
    const number = Number(numericValue) / 100;
    return number.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  const handleChange = (value: string) => {
    setValor(formatCurrency(value));
  };

  const handleConfirm = () => {
    if (!justificativa.trim()) {
      FrontendNotification("Informe a justificativa da sangria", NotificationType.WARNING);
      return;
    }

    // Convert string currency to number if needed
    const numericValue = parseFloat(valor.replace("R$", "").replace(/\./g, "").replace(",", ".").trim());
    onConfirm(numericValue, justificativa.trim());
  };

  return (
    <CustomModal title="Sangria" onClose={onClose}>
      <div className="flex flex-col w-full h-full bg-[#F5F5F5]">
        <div className="p-8 bg-white m-4 rounded-md shadow-sm">
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Sangria</label>
                    <div className="text-gray-500">Valor da Sangria</div>
                </div>
                <div>
                    <InputCustom
                        title="Valor da Sangria"
                        value={valor}
                        onChange={handleChange}
                        placeholder="R$ 0,00"
                    />
                </div>
                <div className="col-span-2">
                  <label htmlFor="justificativa-sangria" className="block text-sm font-medium text-gray-700 mb-1">Justificativa</label>
                  <div className="text-gray-500 mb-2">Motivo da sangria</div>
                  <textarea
                    id="justificativa-sangria"
                    className="w-full min-h-32 rounded-md border border-[#DBDEDF] bg-white px-3 py-2 text-sm text-[#000] resize-y outline-none focus:border-[#0C4A85]"
                    value={justificativa}
                    onChange={(event) => setJustificativa(event.target.value)}
                    placeholder="Informe a justificativa"
                  />
                </div>
            </div>
        </div>
        <div className="flex justify-end p-4 gap-2">
            <button onClick={onClose} className="w-20 h-8 rounded-full bg-[#F9FAFA] text-xs text-[#000] font-bold border border-[#DBDEDF]">Cancelar</button>
            <button onClick={handleConfirm} className="w-20 h-8 rounded-full bg-[#0C4A85] text-xs text-[#fff] font-bold">Salvar</button>
        </div>
      </div>
    </CustomModal>
  );
};

export default ModalSangria;
